module.exports = __webpack_public_path__ + "fonts/AntikorMono-News.587542d7.woff";